<button
  pButton
  class="m-button {{ type }} {{ styleClass }}"
  [disabled]="disabled"
  [style]="style"
  [label]="label">
  <ng-content></ng-content>
</button>
